<!-- NOTE
  4 Types of screen available
  1. screen="home"
  2. screen="splash"
  3. screen="notification"
  4. screen="appLogo"
  Default is Home
-->

<template>
  <div style="position: relative">
    <div class="mobile-frame">
      <img src="@/assets/images/Phone_Frame.png" />
    </div>
    <div v-if="screen == 'home'" class="mobile-body" style="font-family: inherit">
      <div
        class="header-mob"
        :style="` background: linear-gradient(180deg, ${statusBar} 0%, ${headerTop} 99.99%); color:${headerFont};`"
      >
        <div class="status-bar">
          <div class="ml-2">19:02</div>
          <div class="wifi-area">
            <img src="@/assets/images/battery-area.svg" :style="headerIconStyle" />
          </div>
        </div>
        <div class="status-bar--2">
          <div>
            <img
              src="@/assets/images/map-icon.svg"
              alt=""
              :style="headerIconStyle"
            />Pune, Maharastra
            <img src="@/assets/images/down-arrow.svg" :style="headerIconStyle" />
          </div>
          <div>
            20
            <img :style="headerIconStyle" src="@/assets/images/down-arrow.svg" />
          </div>
          <img src="@/assets/images/mobile-headder-icons.svg" :style="headerIconStyle" />
        </div>
        <div class="filter-bar">
          <div class="search-bar-large">
            <img src="@/assets/images/search-icon.svg" />
            Search For Products/Services
          </div>
          <div class="search-bar-small">
            Any
            <img src="@/assets/images/down-arrow.svg" style="float: right" />
          </div>
        </div>
      </div>
      <div class="body-mob">
        <img
          src="@/assets/images/black-friday-sale.png"
          alt=""
          class="sales-advertisement"
        />
        <div class="item-logos">
          <div class="item">
            <img src="@/assets/images/icon-electronics.svg" alt="" />
            Electronics
          </div>
          <div class="item">
            <img src="@/assets/images/icon-grocery.svg" alt="" />
            Grocery
          </div>
          <div class="item">
            <img src="@/assets/images/icon-pharmacy.svg" alt="" />
            Pharmacy
          </div>
          <div class="item">
            <img src="@/assets/images/icon-fashion.svg" alt="" />
            Fashion
          </div>
          <div class="item">
            <img src="@/assets/images/icon-healthcare.svg" alt="" />
            Healthcare
          </div>
          <div class="item">
            <img src="@/assets/images/icon-education.svg" alt="" />
            Education
          </div>
        </div>
        <div class="new-store-labels">
          New Stores
          <div class="search-bar-small-2">
            Local
            <img
              src="@/assets/images/down-arrow.svg"
              style="float: right; margin-top: 3px"
            />
          </div>
          <span style="font-size: 10px"> All Stores &#10093;</span>
        </div>
        <div class="store-area">
          <div class="store-item" v-for="(item, i) in 3" :key="i">
            <img src="@/assets/images/store-item.svg" alt="" />
            <div class="store-name">Store Name</div>
            <div class="distance">5 KM</div>
            <div class="rating">4</div>
            <div class="location">Pune, Maharashtra</div>
          </div>
        </div>
        <div class="m-4"></div>
        <div class="new-store-labels">
          New Arrivals
          <div class="search-bar-small-2" style="margin-left: 40px">
            Ghatal
            <img
              src="@/assets/images/down-arrow.svg"
              style="float: right; margin-top: 3px"
            />
          </div>
          <span style="font-size: 10px"> More &#10093;</span>
        </div>
        <div class="store-area">
          <div class="store-item" v-for="(item, i) in 3" :key="i">
            <img src="@/assets/images/new-item.svg" alt="" />
            <div class="discount">10%</div>
          </div>
        </div>
      </div>
      <div class="footer-mob">
        <div class="el" :style="`color:${footerSelection}`">
          <img src="@/assets/images/icon-home.svg" alt="" :style="footerSelStyle" />
          Home
        </div>
        <div class="el" :style="`color:${footerNormal}`">
          <img src="@/assets/images/icon-shop.svg" alt="" :style="footerNormalStyle" />
          Shop
        </div>
        <div class="el" :style="`color:${footerNormal}`">
          <img src="@/assets/images/icon-quote.svg" alt="" :style="footerNormalStyle" />
          My Quote
        </div>
        <div class="el" :style="`color:${footerNormal}`">
          <img src="@/assets/images/icon-order.svg" alt="" :style="footerNormalStyle" />
          My Order
        </div>
        <div class="el" :style="`color:${footerNormal}`">
          <img src="@/assets/images/icon-profile.svg" alt="" :style="footerNormalStyle" />
          Profile
        </div>
      </div>
    </div>
    <div v-if="screen == 'sellerHome'" class="mobile-body" style="font-family: inherit">
      <div
        class="header-mob"
        :style="` background-color: ${headerTop}; color:${headerFont};`"
      >
        <div class="status-bar">
          <div class="ml-2">22:22</div>
          <div class="wifi-area">
            <img src="@/assets/images/battery-area.svg" :style="headerIconStyle" />
          </div>
        </div>
        <div class="logoArea">
          <div class="showApplogo">
            <!-- <img src="@/assets/images/appLogo.svg" /> -->
            <!-- <img :src="appIcon" v-else /> -->
            <img src="@/assets/images/appLogo.svg" v-if="!appIcon" />
            <img :src="appIcon" v-else />
            <!-- <div class="app-name">{{ appName }}</div> -->
          </div>
          <div class="appNameSec">
            <div class="welcomeSec">Welcome To !</div>
            <div class="sellerAppName" v-if="!appName">Clickmart</div>
            <div class="sellerAppName" v-else>{{ appName }}</div>
          </div>
        </div>
      </div>
      <div class="body-mobile">
        <div>
          <div class="topStatusSec mt-1">
            <div class="statusBox lightBlue">
              <div class="StatusValue">1</div>
              <div class="statusName">Confirmed</div>
            </div>
            <div class="statusBox lightOrange">
              <div class="StatusValue">0</div>
              <div class="statusName">Rejected</div>
            </div>
            <div class="statusBox lightRed">
              <div class="StatusValue">0</div>
              <div class="statusName">Processing</div>
            </div>
          </div>
          <div class="topStatusSec">
            <div class="statusBox lightGreen">
              <div class="StatusValue">1</div>
              <div class="statusName">Completed Orders</div>
            </div>
            <div class="statusBox lightYellow">
              <div class="StatusValue">0</div>
              <div class="statusName">Products Low Stock</div>
            </div>
            <div class="statusBox lightGray">
              <div class="StatusValue">0</div>
              <div class="statusName">Products Sold Out</div>
            </div>
          </div>
        </div>
        <div class="customerLookingSec mt-1">
          <div>157 Customers Looking for Service in your Area</div>
        </div>
        <div class="newSalesAnalysislabels mt-1">
          <div>Sales Analysis</div>
          <div class="search-bar-small-3">
            Current year
            <img
              src="@/assets/images/down-arrow.svg"
              style="float: right; margin-top: 3px"
            />
          </div>
        </div>
        <div class="graphSec">
          <img src="@/assets/images/sellerGraph.svg" alt="" />
        </div>
      </div>
      <div class="footer-mob">
        <div class="el" :style="`color:${footerSelection}`">
          <img src="@/assets/images/icon-home.svg" alt="" :style="footerSelStyle" />
          Home
        </div>
        <div class="el" :style="`color:${footerNormal}`">
          <img
            class="widthImgIcon"
            src="@/assets/images/myItems.svg"
            alt=""
            :style="footerNormalStyle"
          />
          My Items
        </div>

        <div class="el" :style="`color:${footerNormal}`">
          <img src="@/assets/images/icon-order.svg" alt="" :style="footerNormalStyle" />
          My Order
        </div>
        <div class="el" :style="`color:${footerNormal}`">
          <img src="@/assets/images/icon-quote.svg" alt="" :style="footerNormalStyle" />
          Quotes
        </div>
        <div class="el" :style="`color:${footerNormal}`">
          <img src="@/assets/images/icon-profile.svg" alt="" :style="footerNormalStyle" />
          Profile
        </div>
      </div>
    </div>
    <div v-if="screen == 'splash'" :style="splashBGStyle" class="splash-background">
      <img src="@/assets/images/mob-default-img.svg" v-if="!splashIcon" />
      <img :src="splashIcon" v-else />
    </div>
    <div v-if="screen == 'appLogo'" class="splash-background">
      <img src="@/assets/images/app-logos.png" alt="" class="app-logo-img" />
      <div class="app-logo">
        <img src="@/assets/images/mob-default-img.svg" v-if="!appIcon" />
        <img :src="appIcon" v-else />
        <div class="app-name">{{ appName }}</div>
      </div>
    </div>
    <div v-if="screen == 'notification'" class="splash-background">
      <img src="@/assets/images/notification-view.png" alt="" style="width: 110%" />
      <div class="notification-area">
        <img src="@/assets/images/mob-default-img.svg" v-if="!notificationIcon" />
        <img :src="notificationIcon" v-else /><span class="heading"
          >&nbsp; {{ appName }} &nbsp; &nbsp; 3:50 AM</span
        >
        <h5>Dummy Alert</h5>
        <span class="message">
          Lorem Ipsum is simply dummy text of the printing and typesetting industry</span
        >
      </div>
    </div>
  </div>
</template>

<script>
// Note The icon need to be black for colour change to work

class Color {
  constructor(r, g, b) {
    this.set(r, g, b);
  }

  toString() {
    return `rgb(${Math.round(this.r)}, ${Math.round(this.g)}, ${Math.round(this.b)})`;
  }

  set(r, g, b) {
    this.r = this.clamp(r);
    this.g = this.clamp(g);
    this.b = this.clamp(b);
  }

  hueRotate(angle = 0) {
    angle = (angle / 180) * Math.PI;
    const sin = Math.sin(angle);
    const cos = Math.cos(angle);

    this.multiply([
      0.213 + cos * 0.787 - sin * 0.213,
      0.715 - cos * 0.715 - sin * 0.715,
      0.072 - cos * 0.072 + sin * 0.928,
      0.213 - cos * 0.213 + sin * 0.143,
      0.715 + cos * 0.285 + sin * 0.14,
      0.072 - cos * 0.072 - sin * 0.283,
      0.213 - cos * 0.213 - sin * 0.787,
      0.715 - cos * 0.715 + sin * 0.715,
      0.072 + cos * 0.928 + sin * 0.072,
    ]);
  }

  grayscale(value = 1) {
    this.multiply([
      0.2126 + 0.7874 * (1 - value),
      0.7152 - 0.7152 * (1 - value),
      0.0722 - 0.0722 * (1 - value),
      0.2126 - 0.2126 * (1 - value),
      0.7152 + 0.2848 * (1 - value),
      0.0722 - 0.0722 * (1 - value),
      0.2126 - 0.2126 * (1 - value),
      0.7152 - 0.7152 * (1 - value),
      0.0722 + 0.9278 * (1 - value),
    ]);
  }

  sepia(value = 1) {
    this.multiply([
      0.393 + 0.607 * (1 - value),
      0.769 - 0.769 * (1 - value),
      0.189 - 0.189 * (1 - value),
      0.349 - 0.349 * (1 - value),
      0.686 + 0.314 * (1 - value),
      0.168 - 0.168 * (1 - value),
      0.272 - 0.272 * (1 - value),
      0.534 - 0.534 * (1 - value),
      0.131 + 0.869 * (1 - value),
    ]);
  }

  saturate(value = 1) {
    this.multiply([
      0.213 + 0.787 * value,
      0.715 - 0.715 * value,
      0.072 - 0.072 * value,
      0.213 - 0.213 * value,
      0.715 + 0.285 * value,
      0.072 - 0.072 * value,
      0.213 - 0.213 * value,
      0.715 - 0.715 * value,
      0.072 + 0.928 * value,
    ]);
  }

  multiply(matrix) {
    const newR = this.clamp(this.r * matrix[0] + this.g * matrix[1] + this.b * matrix[2]);
    const newG = this.clamp(this.r * matrix[3] + this.g * matrix[4] + this.b * matrix[5]);
    const newB = this.clamp(this.r * matrix[6] + this.g * matrix[7] + this.b * matrix[8]);
    this.r = newR;
    this.g = newG;
    this.b = newB;
  }

  brightness(value = 1) {
    this.linear(value);
  }
  contrast(value = 1) {
    this.linear(value, -(0.5 * value) + 0.5);
  }

  linear(slope = 1, intercept = 0) {
    this.r = this.clamp(this.r * slope + intercept * 255);
    this.g = this.clamp(this.g * slope + intercept * 255);
    this.b = this.clamp(this.b * slope + intercept * 255);
  }

  invert(value = 1) {
    this.r = this.clamp((value + (this.r / 255) * (1 - 2 * value)) * 255);
    this.g = this.clamp((value + (this.g / 255) * (1 - 2 * value)) * 255);
    this.b = this.clamp((value + (this.b / 255) * (1 - 2 * value)) * 255);
  }

  hsl() {
    // Code taken from https://stackoverflow.com/a/9493060/2688027, licensed under CC BY-SA.
    const r = this.r / 255;
    const g = this.g / 255;
    const b = this.b / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h,
      s,
      l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;

        case g:
          h = (b - r) / d + 2;
          break;

        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }

    return {
      h: h * 100,
      s: s * 100,
      l: l * 100,
    };
  }

  clamp(value) {
    if (value > 255) {
      value = 255;
    } else if (value < 0) {
      value = 0;
    }
    return value;
  }
}

class Solver {
  constructor(target, baseColor) {
    this.target = target;
    this.targetHSL = target.hsl();
    this.reusedColor = new Color(0, 0, 0);
  }

  solve() {
    const result = this.solveNarrow(this.solveWide());
    return {
      values: result.values,
      loss: result.loss,
      filter: this.css(result.values),
    };
  }

  solveWide() {
    const A = 5;
    const c = 15;
    const a = [60, 180, 18000, 600, 1.2, 1.2];

    let best = { loss: Infinity };
    for (let i = 0; best.loss > 25 && i < 3; i++) {
      const initial = [50, 20, 3750, 50, 100, 100];
      const result = this.spsa(A, a, c, initial, 1000);
      if (result.loss < best.loss) {
        best = result;
      }
    }
    return best;
  }

  solveNarrow(wide) {
    const A = wide.loss;
    const c = 2;
    const A1 = A + 1;
    const a = [0.25 * A1, 0.25 * A1, A1, 0.25 * A1, 0.2 * A1, 0.2 * A1];
    return this.spsa(A, a, c, wide.values, 500);
  }

  spsa(A, a, c, values, iters) {
    const alpha = 1;
    const gamma = 0.16666666666666666;

    let best = null;
    let bestLoss = Infinity;
    const deltas = new Array(6);
    const highArgs = new Array(6);
    const lowArgs = new Array(6);

    for (let k = 0; k < iters; k++) {
      const ck = c / Math.pow(k + 1, gamma);
      for (let i = 0; i < 6; i++) {
        deltas[i] = Math.random() > 0.5 ? 1 : -1;
        highArgs[i] = values[i] + ck * deltas[i];
        lowArgs[i] = values[i] - ck * deltas[i];
      }

      const lossDiff = this.loss(highArgs) - this.loss(lowArgs);
      for (let i = 0; i < 6; i++) {
        const g = (lossDiff / (2 * ck)) * deltas[i];
        const ak = a[i] / Math.pow(A + k + 1, alpha);
        values[i] = fix(values[i] - ak * g, i);
      }

      const loss = this.loss(values);
      if (loss < bestLoss) {
        best = values.slice(0);
        bestLoss = loss;
      }
    }
    return { values: best, loss: bestLoss };

    function fix(value, idx) {
      let max = 100;
      if (idx === 2 /* saturate */) {
        max = 7500;
      } else if (idx === 4 /* brightness */ || idx === 5 /* contrast */) {
        max = 200;
      }

      if (idx === 3 /* hue-rotate */) {
        if (value > max) {
          value %= max;
        } else if (value < 0) {
          value = max + (value % max);
        }
      } else if (value < 0) {
        value = 0;
      } else if (value > max) {
        value = max;
      }
      return value;
    }
  }

  loss(filters) {
    // Argument is array of percentages.
    const color = this.reusedColor;
    color.set(0, 0, 0);

    color.invert(filters[0] / 100);
    color.sepia(filters[1] / 100);
    color.saturate(filters[2] / 100);
    color.hueRotate(filters[3] * 3.6);
    color.brightness(filters[4] / 100);
    color.contrast(filters[5] / 100);

    const colorHSL = color.hsl();
    return (
      Math.abs(color.r - this.target.r) +
      Math.abs(color.g - this.target.g) +
      Math.abs(color.b - this.target.b) +
      Math.abs(colorHSL.h - this.targetHSL.h) +
      Math.abs(colorHSL.s - this.targetHSL.s) +
      Math.abs(colorHSL.l - this.targetHSL.l)
    );
  }

  css(filters) {
    function fmt(idx, multiplier = 1) {
      return Math.round(filters[idx] * multiplier);
    }
    return `filter: invert(${fmt(0)}%) sepia(${fmt(1)}%) saturate(${fmt(
      2
    )}%) hue-rotate(${fmt(3, 3.6)}deg) brightness(${fmt(4)}%) contrast(${fmt(5)}%);`;
  }
}

export default {
  props: {
    font: {
      type: String,
      default: "",
    },
    primaryColor: {
      type: String,
      default: "#ffffff",
    },
    statusBar: {
      type: String,
      default: "#ffffff",
    },
    headerTop: {
      type: String,
      default: "#ffffff",
    },
    headerBottom: {
      type: String,
      default: "#ffffff",
    },
    headerFont: {
      type: String,
      default: "#ffffff",
    },
    footerNormal: {
      type: String,
      default: "#ffffff",
    },
    footerSelection: {
      type: String,
      default: "#ffffff",
    },
    screen: {
      type: String,
      default: "home",
    },
    splashBGImage: {
      type: String,
      default: null,
    },
    splashIcon: {
      type: String,
      default: null,
    },
    splashBGCol: {
      type: String,
      default: "#ffffff",
    },
    appIcon: {
      type: String,
      default: null,
    },
    notificationIcon: {
      type: String,
      default: null,
    },
    appName: {
      type: String,
      default: "App Name",
    },
  },
  methods: {
    hexToRgb(hex) {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, (m, r, g, b) => {
        return r + r + g + g + b + b;
      });

      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)]
        : null;
    },
    changeToColor(col) {
      const rgb = this.hexToRgb(col);

      const color = new Color(rgb[0], rgb[1], rgb[2]);
      const solver = new Solver(color);
      const result = solver.solve();
      return result.filter;
    },
  },
  computed: {
    headerIconStyle() {
      return this.changeToColor(this.headerFont);
    },
    footerNormalStyle() {
      return this.changeToColor(this.footerNormal);
    },
    footerSelStyle() {
      return this.changeToColor(this.footerSelection);
    },
    splashBGStyle() {
      if (this.splashBGImage) {
        return `background-image:url(${this.splashBGImage});background-color:${this.splashBGCol};`;
      }
      return `background:${this.splashBGCol};`;
    },
  },
  mounted() {
    this.changeToColor("#aa44bb");
  },
};
</script>

<style lang="scss" scoped>
.mobile-body {
  width: 250px;
  height: 500px;
  background: white;
  position: relative;
  font-size: 10px;
  overflow: hidden;
}
.header-mob {
  width: 100%;
  height: 86.02px;
  border-radius: 0;

  box-shadow: 0px 2.2637px 5.65925px rgba(0, 0, 0, 0.15);
}
.status-bar {
  display: flex;
  justify-content: space-between;
  padding: 6px 10px;

  font-size: 10px;
  font-weight: 550;
}
.status-bar--2 {
  display: flex;
  justify-content: space-between;
  padding: 6px 10px;

  font-size: 8px;
  font-weight: 300;
}
.wifi-area {
}
.filter-bar {
  margin: 5px 10px;
  color: #979797;
  font-size: 8px;
}
.search-bar-large {
  width: 72%;
  padding: 3px 5px;
  background: white;
  vertical-align: middle;
  border-radius: 2.26px;
  display: inline-block;
}
.search-bar-small {
  width: 25%;
  padding: 4px 5px;
  background: white;
  vertical-align: middle;
  border-radius: 2.26px;
  display: inline-block;
  margin-left: 6px;
}
.search-bar-small-2 {
  width: 25%;
  padding: 4px 5px;
  background: white;
  vertical-align: middle;
  border-radius: 2.26px;
  display: inline-block;
  margin-left: 6px;
  color: #979797;
  border: 1px solid #dfdfdf;
}
.change-my-color {
  fill: green;
}
.sales-advertisement {
  width: 85%;
  margin: 8px auto;
  display: block;
}
.item-logos {
  display: flex;
  padding: 0 8px;
  .item {
    img {
      width: 25px;
    }
    display: flex;
    margin: 0 5px;
    font-size: 7.5px;
    flex-direction: column;
    align-items: center;
  }
}
.new-store-labels {
  font-size: 12px;
  font-weight: 600;
  color: #000;
  padding: 0 12px;
  margin-top: 20px;
}
.search-bar-small-2 {
  width: 25%;
  padding: 2px 5px;
  margin-left: 40px;
  background: white;
  vertical-align: middle;
  border-radius: 2.26px;
  display: inline-block;
  font-size: 8px;
  color: #979797;
  border: 1px solid #dfdfdf;
  margin-right: 10px;
}
.store-area {
  display: flex;
  padding-top: 12px;
  .store-item {
    position: relative;
    margin-left: 10px;
    .store-name {
      position: absolute;
      z-index: 1;
      font-size: 7.5px;
      color: rgb(252, 252, 252);
      bottom: 24px;
      left: 6px;
      font-weight: 500;
    }
    .distance {
      position: absolute;
      z-index: 1;
      font-size: 7.5px;
      color: black;
      bottom: 9px;
      left: 16px;
      font-weight: 520;
    }
    .rating {
      position: absolute;
      z-index: 1;
      font-size: 7.5px;
      color: black;
      bottom: 9px;
      right: 0px;
      font-weight: 520;
    }
    .location {
      position: absolute;
      z-index: 1;
      font-size: 7.5px;
      color: black;
      bottom: -2px;
      left: 8px;
      font-weight: 500;
    }
    .discount {
      position: absolute;
      z-index: 1;
      font-size: 7.5px;
      color: rgb(255, 255, 255);
      top: 5px;
      left: 8px;
      font-weight: 500;
    }
  }
}
.footer-mob {
  height: 46.41px;
  width: 100%;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: space-around;
  background: white;
  align-items: flex-end;
  padding-bottom: 6px;
  .el {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 8px;
  }
}
.mobile-frame {
  position: absolute;
  z-index: 2;

  bottom: -20px;
  left: -18.5px;
  img {
    display: block;
    width: 284px;
    height: 538px;
    object-fit: fill;
  }
}
.splash-background {
  display: flex;
  width: 250px;
  height: 500px;
  background: white;
  position: relative;
  font-size: 10px;
  overflow: hidden;
  align-content: center;
  justify-content: center;
  background-size: 100% 100%;
  img {
    width: 100px;
    height: auto;
    object-fit: contain;
  }
  .app-logo-img {
    width: 100%;
    height: 100%;
    position: absolute;
    left: -1px;
  }
}
.app-logo {
  width: 37px;
  height: 37px;
  z-index: 2;
  border-radius: 10px;
  background: white;
  bottom: 73px;
  right: 20px;
  position: absolute;
  padding: 5px;
  .app-name {
    position: absolute;
    color: white;
    bottom: -15px;
    left: 6px;
    font-size: 7px;
    width: 100px;
  }
  img {
    width: 100%;
    object-fit: contain;
    vertical-align: middle;
  }
}
.notification-area {
  width: 90%;
  height: 45px;
  top: 160px;

  border-radius: 10px;
  position: absolute;
  background: white;
  img {
    width: 15px;
    height: auto;
    padding-left: 5px;
  }
  h5 {
    font-size: 8px;
    line-height: 9.5px;
    margin: 0 5px;
  }
  .heading {
    color: #3c0990;
    font-size: 8px;
    font-weight: 550;
  }
  .message {
    font-size: 6px;
    line-height: 8px;
    margin-left: 5px;
  }
}
.logoArea {
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 6px 16px;
  margin-top: 6px;
}
.logoArea .showApplogo {
  margin-right: 8px;
}
.logoArea .welcomeSec {
  font-size: 14px;
  font-weight: 500;
}
.logoArea .sellerAppName {
  font-size: 10px;
  font-weight: 300;
}
.lightBlue {
  background: #5979ea;
}
.lightOrange {
  background: #ff9c27;
}
.lightRed {
  background: #ff5d5b;
}
.lightGreen {
  background: #5aea93;
}
.lightYellow {
  background: #ffe249;
}
.lightGray {
  background: #b7b7b7;
}
.topStatusSec {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
}

.topStatusSec .statusBox {
  border-radius: 10px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  height: 60px;
  width: 70px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  position: relative;
  padding: 6px;
}
.statusBox .StatusValue {
  position: absolute;
  top: 6px;
  right: 13px;
  font-size: 12px;
  font-weight: 500;
}
.statusBox .statusName {
  font-size: 12px;
  font-weight: 600;
  margin-top: 10px;
  text-align: left;
  line-height: 13px;
}
.customerLookingSec {
  background: #5979ea;
  color: #fff;
  padding: 16px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  margin: 0 10px;
  font-size: 10px;
  font-weight: 500;
}
.newSalesAnalysislabels {
  font-size: 12px;
  font-weight: 500;
  color: #000;
  padding: 6px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.search-bar-small-3 {
  width: 38%;
  padding: 10px 6px;
  background: #fff;
  vertical-align: middle;
  border-radius: 6px;
  display: inline-block;
  font-size: 10px;
  color: #000;
  border: 1px solid #000;
  text-transform: capitalize;
}
.widthImgIcon {
  width: 20px;
}
.graphSec {
  text-align: center;
}
.graphSec img {
  width: 90%;
}
.showApplogo img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
</style>
